<template>
	<div>
		<Head title="Kategorier" />

		<h1 class="mb-8 text-3xl font-bold">Kategorier</h1>

		<div class="mb-6 flex items-center justify-between">
			<SearchFilter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
				<label class="block text-gray-700">Huvud-/underkategori:</label>

				<select v-model="form.parent" class="form-select mt-1 w-full">
					<option :value="null"></option>
					<option value="true">Är huvudkategori</option>
					<option value="false">Är underkategori</option>
				</select>
			</SearchFilter>

			<Link class="btn-cta" href="/categories/create">
				<span>{{ __('Create') }}</span>
				<span class="hidden md:inline">&nbsp;Kategori</span>
			</Link>
		</div>

		<div class="overflow-x-auto rounded-md bg-white shadow">
			<table class="w-full whitespace-nowrap">
				<thead>
					<tr class="text-left font-bold">
						<th class="px-6 pb-4 pt-6">Namn</th>
						<th class="px-6 pb-4 pt-6">Huvudkategori</th>
						<th class="px-6 pb-4 pt-6">Färgschema</th>
					</tr>
				</thead>

				<tbody>
					<tr
						v-for="category in categories.data"
						:key="category.id"
						class="focus-within:bg-gray-100 hover:bg-gray-100"
					>
						<td class="border-t">
							<Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/categories/${category.id}/edit`">
								{{ category.name }}

								<Icon v-if="category.deleted_at" name="trash" class="ml-2 h-3 w-3 flex-shrink-0 fill-gray-400" />
							</Link>
						</td>

						<td class="border-t">
							<span v-if="category.parent" class="px-6 py-4">
								{{ category.parent.name }}
							</span>

							<span v-else class="px-6 py-4"> - </span>
						</td>

						<td class="border-t">
							<span v-if="!category.parent" class="px-6 py-4">
								<span v-if="category.color_scheme == 'default'">Standard</span>
								<span v-if="category.color_scheme == 'blue'">Pfizer Pro</span>
								<span v-if="category.color_scheme == 'purple'">Eliquis</span>
							</span>

							<span v-else class="px-6 py-4"> - </span>
						</td>

						<td class="w-px border-t">
							<Link class="flex items-center px-4" :href="`/categories/${category.id}/edit`" tabindex="-1">
								<Icon name="cheveron-right" class="block h-6 w-6 fill-gray-400" />
							</Link>
						</td>
					</tr>

					<tr v-if="categories.data.length === 0">
						<td class="border-t px-6 py-4" colspan="4">{{ __('No categories found.') }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<Pagination class="mt-6" :links="categories.links" />
	</div>
</template>

<script>
	import { Head, Link } from '@inertiajs/inertia-vue3'
	import pickBy 		  from 'lodash/pickBy'
	import throttle 	  from 'lodash/throttle'
	import mapValues 	  from 'lodash/mapValues'
	import Layout 		  from '@/Shared/Layout'
	import Icon 		  from '@/Shared/Icon'
	import Pagination 	  from '@/Shared/Pagination'
	import SearchFilter   from '@/Shared/SearchFilter'

	export default {
		components: {
			Head,
			Icon,
			Link,
			Pagination,
			SearchFilter,
		},
		layout: Layout,
		props: {
			filters: Object,
			categories: Object,
		},
		data() {
			return {
				form: {
					search: this.filters.search,
					trashed: this.filters.trashed,
				}
			}
		},
		watch: {
			form: {
				deep: true,
				handler: throttle(function () {
					this.$inertia.get('/categories', pickBy(this.form), { preserveState: true })
				}, 150)
			}
		},
		methods: {
			reset() {
				this.form = mapValues(this.form, () => null)
			}
		}
	}
</script>
